export const rankBatters = {
  C: 1,
  "1B": 2,
  "2B": 3,
  SS: 4,
  "3B": 5,
  OF: 6,
  UTIL: 7,
  DH: 8,
  BN: 9,
};
export const rankPitchers = {
  SP: 1,
  RP: 2,
  P: 3,
};

export const positionOptions = [
  { key: "C", text: "C", value: "C" },
  { key: "1B", text: "1B", value: "1B" },
  { key: "2B", text: "2B", value: "2B" },
  { key: "SS", text: "SS", value: "SS" },
  { key: "3B", text: "3B", value: "3B" },
  { key: "OF", text: "OF", value: "OF" },
  { key: "DH", text: "DH", value: "DH" },
  { key: "UTIL", text: "UTIL", value: "UTIL" },
  { key: "BN", text: "BN (ONLY HITTERS)", value: "BN" },
  { key: "SP", text: "SP", value: "SP" },
  { key: "RP", text: "RP", value: "RP" },
  { key: "P", text: "P (USE FOR BENCH)", value: "P" },
];

export function sumSalary(team) {
  let total = 0;
  team.forEach((player) => {
    let salary = "";
    for (let char of player.salary) {
      if ((char >= 0 && char <= 9) || char === ".") {
        salary += char;
      } else {
        break;
      }
    }
    // console.log(salary);
    total += parseFloat(salary);
    // console.log(total);
  });
  // console.log(total);
  if (total === isNaN()) {
    return "Please Fix Salary Values";
  }
  return total;
}

// module.exports = {
//   rankBatters,
//   rankPitchers,
//   sumSalary,
// };
